module.exports = __webpack_public_path__ + "img/site-kvv.2e8c00f7.png";